import humps from 'humps'
import { createFormDataDocuments, notEmptyPayload } from '_utils/helpers'

import { get, patch, post, del } from './requests'
import { getToken } from '_/utils/token'

export const getProviders = key => params =>
  get(['companyboard'], {
    key,
    params: humps.decamelizeKeys(params),
    transformPayload: true,
  })

export const getProvidersByOrigin = key => params =>
  get(['companyboard', 'providers-by-origin'], {
    key,
    params: humps.decamelizeKeys(params),
    transformPayload: true,
  })

export const getProvidersList = key => params =>
  get(['companyboard'], {
    key,
    params: humps.decamelizeKeys(params),
    transformPayload: true,
  })

export const getAgencyProviders = key => params =>
  get(['agency-providers'], {
    key,
    params: humps.decamelizeKeys(params),
    transformPayload: true,
  })

export const patchAgencyProviderLink = key => (companyId, agencyId, payload) =>
  patch(
    ['agency-providers', companyId],
    { key, transformPayload: true, params: { agency_id: agencyId } },
    payload
  )

export const deleteAgencyProviderLink = key => (companyId, agencyId) =>
  del(['agency-providers', companyId], { key, transformPayload: true }, { companyId, agencyId })

export const getProvider = key => (providerId, params) =>
  get(['company', providerId], {
    key,
    params: humps.decamelizeKeys(params),
    transformPayload: true,
  })

export const getLeadProviders = key => params =>
  get(['lead-providers'], {
    key,
    transformPayload: true,
    params: humps.decamelizeKeys(notEmptyPayload(params)),
  })

export const importLeadProviders = key => payload =>
  post(
    ['lead-providers', 'import-companies'],
    {
      key,
      transformPayload: true,
    },
    payload
  )

export const updateProvider = key => (providerId, payload) => {
  const newPayload = { ...payload }
  if (typeof newPayload?.brandLogoPngUrl === 'string') {
    delete newPayload.brandLogoPngUrl
  }
  return patch(
    ['company', providerId],
    {
      key,
      transformPayload: false,
      formData: true,
    },
    createFormDataDocuments(newPayload)
  )
}
export const createProvider = key => payload =>
  post(
    ['company'],
    {
      key,
      transformPayload: false,
      formData: true,
    },
    createFormDataDocuments(payload)
  )

export const createProviderContract = key => (providerId, payload) =>
  post(
    ['company', providerId, 'create-contract'],
    { key, transformPayload: false, formData: true },
    createFormDataDocuments(payload)
  )

export const createCompany = payload => {
  const headers = getToken()
  const shouldTransformIntoFormData = payload?.brandLogo instanceof Blob

  return post(
    ['company'],
    {
      ...headers,
      transformPayload: true,
      transformFormData: shouldTransformIntoFormData,
      formData: shouldTransformIntoFormData,
    },
    payload
  )
}

export const updateCompanyById = (providerId, payload) => {
  const headers = getToken()

  const shouldTransformIntoFormData = payload?.brandLogo instanceof Blob

  return patch(
    ['company', providerId],
    {
      ...headers,
      transformPayload: true,
      transformFormData: shouldTransformIntoFormData,
      formData: shouldTransformIntoFormData,
    },
    payload
  )
}

export const deleteProviderAttachment = key => (providerId, attachmentId) =>
  patch(['company', providerId, 'delete-attachment'], { key }, { attachmentId })

export const deleteProviderContract = key => (providerId, attachmentId) =>
  patch(['company', providerId, 'delete-contract'], { key }, { attachmentId })

export const addProviderStaffUser = key => (providerId, payload) =>
  post(['company', providerId, 'staff-users'], { key, transformPayload: true }, payload)

export const deleteProviderStaffUser = key => (providerId, staffId) =>
  del(['company', providerId, 'staff-users', staffId], { key, transformPayload: true })

export const updateProviderStaffUser = key => (providerId, staffId, payload) =>
  patch(['company', providerId, 'staff-users', staffId], { key, transformPayload: true }, payload)

export const getProviderStaffUsers =
  key =>
  (providerId, userId = undefined, params = {}) => {
    const path = userId
      ? ['company', providerId, 'staff-users', userId]
      : ['company', providerId, 'staff-users']
    return get(path, { key, transformPayload: true, params })
  }

export const getCompanyUsers =
  key =>
  (providerId, params = {}) => {
    return get(['company', providerId, 'users'], { key, transformPayload: true, params })
  }

export const getConnetionMessageTool = key => params =>
  get(['connections-message-tool'], {
    key,
    params: humps.decamelizeKeys(params),
    transformPayload: true,
  })

export const getProviderSuggestionsList = key => payload =>
  post(
    ['companyboard/assisted-distribution-providers'],
    {
      key,
      transformPayload: true,
    },
    payload
  )

export const getProviderOrders = key => params =>
  post(
    ['company/get-provider-orders'],
    {
      key,
      transformPayload: true,
    },
    params
  )

export const validateProviderCpfCnpj = key => params =>
  get(['company', 'validate-cpf-cnpj'], {
    key,
    params: humps.decamelizeKeys(params),
    transformPayload: true,
  })

export const getServiceProviderOptions = () => {
  const headers = getToken()

  return get(['serviceprovider/get-options'], {
    ...headers,
  })
}

export const rateProvider = key => payload =>
  post(['serviceprovider-agency-rating'], { key, transformPayload: true }, payload)

export const updateProviderRate = key => (id, payload) =>
  patch(['serviceprovider-agency-rating', id], { key, transformPayload: true }, payload)

export const getProviderRates = key => params =>
  get(['serviceprovider-agency-rating/averages'], {
    key,
    transformPayload: true,
    params: humps.decamelizeKeys(notEmptyPayload(params)),
  })

export const requestReferaProviders = key => payload =>
  post(
    ['company/request-refera-providers'],
    {
      key,
      transformPayload: true,
    },
    payload
  )
